import { render, staticRenderFns } from "./Article_Create.vue?vue&type=template&id=2109b2de&scoped=true&"
import script from "./Article_Create.vue?vue&type=script&lang=js&"
export * from "./Article_Create.vue?vue&type=script&lang=js&"
import style0 from "./Article_Create.vue?vue&type=style&index=0&id=2109b2de&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2109b2de",
  null
  
)

component.options.__file = "Article_Create.vue"
export default component.exports